import { isEqual } from 'lodash'
import { stateOptions } from '@/tools/formData'

export function getPropByPath(obj, path, strict) {
    let tempObj = obj
    path = path.replace(/\[(\w+)\]/g, '.$1')
    path = path.replace(/^\./, '')

    const keyArr = path.split('.')
    let i = 0
    for (let len = keyArr.length; i < len - 1; ++i) {
        if (!tempObj && !strict) break
        const key = keyArr[i]
        if (key in tempObj) {
            tempObj = tempObj[key]
        } else {
            if (strict) {
                throw new Error('please transfer a valid prop path to form item!')
            }
            break
        }
    }
    return {
        o: tempObj,
        k: keyArr[i],
        v: tempObj ? tempObj[keyArr[i]] : null,
    }
}

export function noop() {}

// 判断email格式是否正确
export function isEmail(email) {
    const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return emailReg.test(email)
}

// 获得target和origin中不同的元素
export function difference(origin, target) {
    const newObj = {}
    for (const key in origin) {
        if (!isEqual(origin[key], target[key])) newObj[key] = target[key]
    }
    return newObj
}

// 初始化endorsement/freightType/routeExperience等多选
export const initRegisterOptions = array => {
    const last = {}
    array.forEach(element => {
        last[element.value] = null
    })
    return last
}

// search location
export const searchFromLocation = query => {
    const options = stateOptions.filter(item => {
        return item.label.toLowerCase().includes(query.toLowerCase())
    })
    return options
}

// 监听滚动条滚到底事件
export const listenerScrollToBottom = callback => {
    // 监听浏览器滚动事件，触底触发回调函数
    window.addEventListener('scroll', listen)
    function clearListener() {
        window.removeEventListener('scroll', listen)
    }
    function listen() {
        const scrollHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
        )
        const clientHeight = Math.max(
            document.body.clientHeight,
            document.documentElement.clientHeight
        )
        const scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop)
        if (Math.ceil(clientHeight + scrollTop + 20) >= scrollHeight) {
            callback()
        } else {
            //console.log('scrollHeight: ', scrollHeight, ' clientHeight: ', clientHeight, ' scrollTop: ', scrollTop);
        }
    }
    return clearListener
}

// 监听滚动条滚到底事件
export const listenerFixedJobBoard = callback => {
    // 监听浏览器滚动事件，触底触发回调函数

    function listen() {
        const TOP = 250
        const scrollTop =
            document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        if (scrollTop >= TOP) {
            callback(true)
        } else {
            callback(false)
        }
    }
    function clearListener() {
        window.removeEventListener('scroll', listen)
    }
    window.addEventListener('scroll', listen)
    return clearListener
}

// 格式化成数字
export const formatToNumber = str => {
    return str.replace(/[^\d]/g, '')
}

// 保留几位小数
export const formatToFloat = (str, fix) => {
    str = str.replace(/[^\d.]/g, '')
    const reg = new RegExp(`(?<=\\.\\d{${fix}})\\d+`, 'g')
    str = str.replace(reg, '')
    return str
}

// 格式化成phone
export const formatToPhone = str => {
    const num = formatToNumber(str)
    const c = num
        .match(/(\d{3})?(\d{3})?(\d{4})?(\d*)/i)
        .slice(1)
        .filter(v => v)
        .slice(0, 3)
    return c[0] ? c[0] + (c[1] ? '-' + c[1] + (c[2] ? '-' + c[2] : '') : '') : ''
}

// sleep 函数
export const sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms))
}
